import axios from "axios";
import { aspNetUrl } from "../../axiosInstance";

export const getCoupons = () => {
  return axios
    .get(`${aspNetUrl}coupons`)
    .then((res) => res.data)
    .catch((e) => console.log(e));
};

export const createCoupon = (data) => {
  return axios.post(`${aspNetUrl}Coupon/AddCoupon`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const useCoupon = (couponCode, customerId, orderId) => {
  return axios
    .post(
      `${aspNetUrl}Coupon/RedeemCoupon?couponCode=${couponCode}&customerId=${customerId}&orderId=${orderId}`,
      {
        headers: {
          Authorization: `bearer ${localStorage.token}`,
          "Access-Control-Allow-Origin": "*",
        },
      },
    )
    .then((res) => res.data)
    .catch((e) => console.log(e));
};

export const validateCoupon = async (couponCode, customerId) => {
  try {
    const res = await axios.get(
      `${aspNetUrl}Coupon/ValidateCoupon?couponCode=${couponCode}&customerId=${customerId}`,
      {
        headers: {
          Authorization: `bearer ${localStorage.token}`,
          "Access-Control-Allow-Origin": "*",
        },
      },
    );
    return res.data;
  } catch (e) {
    return console.log(e);
  }
};
